import { distinctUntilChanged, filter, fromEvent, map, Observable } from 'rxjs';
import {
  getLogAd$,
  LOG_ADS,
  LOG_MISSING_AD,
} from '@tv2-player/static-commercial/getLogAdObservable';
import { GoogleTagObject } from './types';
import { skipBetween } from './skipBetween';
import { getLogger } from '../handlers/error';
import cast from '../types/chromecast-caf-receiver';

export function logPauseAds(
  event$: Observable<Event>,
  breakStarted$: Observable<Event>,
  breakEnded$: Observable<Event>
) {
  const { EventType } = cast.framework.events;
  const googletag: GoogleTagObject = window.googletag || { cmd: [] };
  googletag.cmd.push(() => {
    const currentAd = googletag.pubads();
    const eventsWithoutBreaks$ = event$.pipe(skipBetween(breakStarted$, breakEnded$));

    const ad$ = fromEvent(currentAd, 'slotVisibilityChanged').pipe(
      map(event => event.slot.getEscapedQemQueryId()),
      distinctUntilChanged(),
      filter(x => Boolean(x))
    );
    const pause$ = eventsWithoutBreaks$.pipe(filter(({ type }) => type === EventType.PAUSE));
    const play$ = eventsWithoutBreaks$.pipe(filter(({ type }) => type === EventType.PLAY));
    const logAd$ = getLogAd$(pause$, play$, ad$);
    const logger = getLogger();
    logAd$.subscribe(x => {
      if (x === LOG_ADS) {
        logger?.info({
          location: window.location,
          info: { name: 'info', raw: {} },
          data: {},
          context: `show-static-commercial`,
        });
      }

      if (x === LOG_MISSING_AD) {
        logger?.info({
          location: window.location,
          data: {},
          info: { name: 'info' },
          context: `missed-static-commercial`,
        });
      }
    });
  });
}
